import { render, staticRenderFns } from "./EEDashboardLayout.vue?vue&type=template&id=4a60c229&"
import script from "./EEDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./EEDashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports